import PrazoFaturamentoHandler from "@/features/contabil/common/prazo/PrazoFaturamentoHandler";
import ContabilShortcutHandler from "@/features/contabil/composables/Shortcuts/ContabilHandler";
import ShortcutObrigacoesHandler from "@/features/contabil/composables/Shortcuts/obrigacoes/ObrigacoesContabilHandler";
import { IShortcutHandler } from "@/core/composables/F360DateShortcuts/types";
import AutocontratacaoHttpGateway from "@/features/contabil/services/autocontratacao/AutocontratacaoHttpGateway";
import { IDashboardGateway } from "@/features/contabil/services/dashboard/gateways/DashboardGateway";
import DashboardHttpGateway from "@/features/contabil/services/dashboard/gateways/DashboardHttpGateway";
import { IDashboardLucroGateway } from "@/features/contabil/services/dashboard/gateways/DashboardLucroGateway";
import DashboardLucroHttpGateway from "@/features/contabil/services/dashboard/gateways/DashboardLucroHttpGateway";
import ObrigacoesFiscais from "@/features/contabil/services/dashboard/gateways/ObrigacoesFiscais";
import ReceitaFederal from "@/features/contabil/services/dashboard/gateways/ReceitaFederal";
import Empecilhos from "@/features/contabil/services/dashboard/gateways/entity/Empecilhos";
import { DashboardContabilDITypes } from "@/features/contabil/services/dashboard/types";
import { IDiagnosticoGateway } from "@/features/contabil/services/diagnostico/gateways/DiagnosticoGateway";
import DiagnosticoHttpGateway from "@/features/contabil/services/diagnostico/gateways/DiagnosticoHttpGateway";
import { ISharedGateway } from "@/features/contabil/services/shared/gateways/SharedGateway";
import SharedHttpGateway from "@/features/contabil/services/shared/gateways/SharedHttpGateway";
import { ContabilDITypes } from "@/features/contabil/services/types";
import ReceitaFederalInteractor from "@/features/contabil/dashboard/widgets/CadinSituacaoFiscal/ReceitaFederalService";
import { IReceitaFederalService } from "@/features/contabil/dashboard/widgets/CadinSituacaoFiscal/ReceitaFederalUseCase";
import { ContainerModule } from "inversify";
import { diContainer } from "@/core/di";
import { controleDebitosContainer } from "./controleDebitos";
import {
  IUsuariosPorEmpresaGateway,
  usuariosPorEmpresaGatewayDI
} from "@/features/contabil/comunicacao/ports/UsuarioPorEmpresaGateway";
import {
  IUsuarioPorEmpresaUseCase,
  usuariosPorEmpresaUseCaseDI
} from "@/features/contabil/comunicacao/ports/UsuarioPorEmpresaUseCase";
import { UsuarioPorEmpresaGatewayAdapter } from "@/features/contabil/comunicacao/adapters/UsuarioPorEmpresaGatewayAdapter";
import { UsuarioPorEmpresaUseCase } from "@/features/contabil/comunicacao/adapters/UsuarioPorEmpresaUseCaseAdapter";
import { PeriodoDocumentoDisponivel } from "@/features/contabil/common/PeriodoDocumentosDisponiveis";
import { CSATContainer } from "@/features/contabil/components/ContabilCSAT/container";
import { visaoEstrategicaContainer } from "@/features/contabil/dashboardTributacao/container";

const contabilContainer = new ContainerModule((bind) => {
  bind<IDashboardGateway>(ContabilDITypes.DASHBOARD_GATEWAY).to(
    DashboardHttpGateway
  );
  bind<IDiagnosticoGateway>(ContabilDITypes.DIAGNOSTICO_GATEWAY).to(
    DiagnosticoHttpGateway
  );
  bind<ISharedGateway>(ContabilDITypes.SHARED_GATEWAY).to(SharedHttpGateway);
  bind<IDashboardLucroGateway>(ContabilDITypes.DASHBOARD_LUCRO_GATEWAY).to(
    DashboardLucroHttpGateway
  );
  bind<IShortcutHandler<string>>(ContabilDITypes.OBRIGACOES_SHORTCUTS).to(
    ShortcutObrigacoesHandler
  );
  bind<IShortcutHandler<unknown>>(ContabilDITypes.CONTABIL_SHORTCUTS).to(
    ContabilShortcutHandler
  );
  bind<AutocontratacaoHttpGateway>(ContabilDITypes.AUTOCONTRATACAO_GATEWAY).to(
    AutocontratacaoHttpGateway
  );
  bind(PrazoFaturamentoHandler).to(PrazoFaturamentoHandler);
  bind<IUsuariosPorEmpresaGateway>(usuariosPorEmpresaGatewayDI).to(
    UsuarioPorEmpresaGatewayAdapter
  );
  bind<IUsuarioPorEmpresaUseCase>(usuariosPorEmpresaUseCaseDI).to(
    UsuarioPorEmpresaUseCase
  );
  bind<PeriodoDocumentoDisponivel>(PeriodoDocumentoDisponivel).toSelf();
  diContainer.load(CSATContainer);
  diContainer.load(visaoEstrategicaContainer);
});
const contabilDashboardContainer = new ContainerModule((bind) => {
  bind<IReceitaFederalService>(DashboardContabilDITypes.RECEITA_FEDERAL_SERVICE)
    .to(ReceitaFederalInteractor)
    .inRequestScope();
  bind(ObrigacoesFiscais).to(ObrigacoesFiscais).inRequestScope();
  bind(ReceitaFederal).toSelf().inRequestScope();
  bind(Empecilhos).toSelf().inRequestScope();
  diContainer.load(controleDebitosContainer);
});

const contabilDashboardEstrategicaContainer = new ContainerModule(() => {
  //teste
});

export {
  contabilContainer,
  contabilDashboardContainer,
  contabilDashboardEstrategicaContainer
};
